const useStyles = {
  alertsHeaderRow: () => ({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 2,
    paddingBottom: 1,
  }),
  alertsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontWeight: 500,
  },
  categoryButtonGroup: {
    paddingTop: 0,
    paddingBottom: 1.5,
    gap: 0,
  },
  noAlertsContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 2,
    marginTop: '150px',
  },
  noAlertsText: {
    textAlign: 'center',
    marginTop: 2,
    fontSize: '30px',
    lineHeight: '40px',
    letterSpacing: 0,
  },
  alertsListContainer: {
    flexDirection: 'column',
    rowGap: 2,
  },
  alertGroupContainer: {
    flexDirection: 'column',
    gap: 1,
  },
  alertGroupHeader: {
    display: 'flex',
    padding: 1,
    paddingTop: 2,
    alignItems: 'center',
    gap: 1,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginY: 3,
  },
  skeletonGrid: {
    marginTop: 2,
    gap: 1,
  },
  skeletonButtonGroup: {
    marginY: 1.5,
  },
  skeletonDateHeader: {
    marginTop: 1,
  },
}

export default useStyles
